import { render, staticRenderFns } from "./AddressTime.vue?vue&type=template&id=04d59d57&scoped=true"
import script from "./AddressTime.vue?vue&type=script&lang=js"
export * from "./AddressTime.vue?vue&type=script&lang=js"
import style0 from "./AddressTime.vue?vue&type=style&index=0&id=04d59d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d59d57",
  null
  
)

export default component.exports